module.exports = __webpack_public_path__ + "static/media/banner_below_image_4.e422bd5b.svg";